import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";

const PLUS_TINT = "rgba(87, 242, 139, 0.15)";
const PLUS_GLOW = "radial-gradient(120% 140% at 0% 0%, rgba(87, 242, 139, 0.18) 0%, rgba(87, 242, 139, 0) 60%)";

/* Inline, top-to-bottom flow: pitch, locked metrics, illustrative chart, benefits and CTA */
export const LockedPreviewBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding-bottom: 2rem;

  .actions {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    align-items: center;
    margin-top: 0.25rem;
  }

  .cta {
    width: 100%;
    padding: 1rem;
    font-family: Inter, sans-serif;
    font-size: 0.9375rem;
    font-weight: 800;
    color: var(--color-neutral-darkness);
    background: var(--color-brand-plus);
    border-radius: 100px;
    box-shadow: 0 8px 24px rgba(87, 242, 139, 0.25);
    transition: filter 0.15s;

    &:hover {
      filter: brightness(1.08);
    }
  }

  .later {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--color-neutral-150);

    &:hover {
      color: var(--color-neutral-white);
    }
  }
`;

export const Hero = styled.header`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: flex-start;
  padding: 1.5rem;
  background: ${PLUS_GLOW}, var(--color-neutral-dark);
  border-radius: 1rem;

  h2 {
    font-size: 1.375rem;
    font-weight: 600;
    line-height: 1.875rem;
    color: var(--color-neutral-white);
  }
`;

export const Metrics = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;

  .metric {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    background: var(--color-neutral-dark);
    border: 1px solid transparent;
    border-radius: 12px;

    &.active {
      border-color: rgba(87, 242, 139, 0.5);
    }
  }

  .label {
    overflow: hidden;
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    color: var(--color-neutral-150);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .value {
    display: flex;
    gap: 0.375rem;
    align-items: center;
    font-family: Inter, sans-serif;
    font-size: 1.25rem;
    font-weight: 800;
    line-height: 1.5rem;
    color: var(--color-neutral-white);
    letter-spacing: 0.1em;

    svg {
      flex-shrink: 0;
      width: 14px;
      height: 14px;
      color: var(--color-brand-plus);
    }
  }
`;

/* The chart uses fake data, so it's labeled as illustrative */
export const ChartArea = styled.div`
  position: relative;
  padding: 2.25rem 1.25rem 0.5rem;
  background: var(--color-neutral-dark);
  border-radius: 12px;

  .sample {
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    padding: 0.125rem 0.5rem;
    font-family: Inter, sans-serif;
    font-size: 0.625rem;
    font-weight: 700;
    color: var(--color-neutral-white);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    background: var(--color-neutral-base);
    border-radius: 100px;
  }
`;

export const Benefits = styled.ul`
  display: grid;
  gap: 0.75rem;
  list-style: none;

  @media (min-width: ${DESKTOP_BREAKPOINT}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  li {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    padding: 1rem;
    font-family: Inter, sans-serif;
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1.125rem;
    color: var(--color-neutral-white);
    background: var(--color-neutral-dark);
    border-radius: 12px;
  }

  .check {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    color: var(--color-brand-plus);
    background: ${PLUS_TINT};
    border-radius: 100%;

    svg {
      width: 11px;
      height: 11px;
    }
  }
`;
